export const ACCOUNT_INFO_TYPE = {
  EMAIL: 'email',
  PASSWORD: 'password',
  USERNAME: 'username',
  WITHDRAWAL: 'withdraw'
};
